// src/frontend/src/api/starterKitApi.ts
import api from './api';

export interface StarterKit {
  _id: string;
  name: string;
  slug: string;
  description: string;
  careerStage: string;
  icon: string;
  color: string;
  targetAudience: string;
  estimatedDuration: string;
  learningOutcomes: string[];
  isActive: boolean;
  orderIndex: number;
  userProgress?: KitProgress | null;
}

export interface KitProgress {
  _id: string;
  user: string;
  starterKit: string;
  status: 'not_started' | 'in_progress' | 'completed';
  currentScenarioIndex: number;
  scenarioProgress: ScenarioProgress[];
  startedAt: string;
  completedAt?: string;
  averageScore?: number;
}

export interface ScenarioProgress {
  scenario: string | any;
  conversation?: string;
  status: 'not_started' | 'in_progress' | 'completed';
  score?: number;
  completedAt?: string;
  orderIndex: number;
}

export interface KitWithDetails {
  kit: StarterKit;
  scenarios: any[];
  progress: KitProgress;
}

// Starter Kit API services
export const starterKitService = {
  // Get all starter kits with user progress
  getStarterKits: () => api.get('/starter-kits'),

  // Get specific kit by slug with scenarios and progress
  getStarterKitBySlug: (slug: string) => api.get(`/starter-kits/${slug}`),

  // Start the next scenario in a kit
  startNextScenario: (slug: string) => api.post(`/starter-kits/${slug}/start-next`),

  // Update scenario progress (called after conversation completion)
  updateScenarioProgress: (conversationId: string, score: number) => 
    api.post('/starter-kits/update-progress', { conversationId, score }),

  // Get user's progress across all kits
  getMyKitProgress: () => api.get('/starter-kits/my-progress'),
};

export default starterKitService;